import { createTheme } from '@material-ui/core/styles';

export const vaisandTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            // Azul VAISAND — Pantone 280C
            main: '#001F66',
            contrastText: '#FFFFFF',
        },
        secondary: {
            // Azul complementario — Pantone 2387C
            main: '#1959D9',
            contrastText: '#FFFFFF',
        },
        error: {
            // Naranja acento — Pantone 172C (usado para alertas/acciones)
            main: '#FF400D',
        },
        divider: '#0D2550',
    },
});
